import React, { Component, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import '../../../Assets/css/index.scss'
import Loading from '../../../Libs/Helper/Loading'
import { getApps, setCaptcha } from '../Reducer/AppReducer';
import { BootAuthReducer } from '../../LoginForm/Reducer/LoginReducer';
import { storageGet } from '../../../Libs/Collector/StorageAction';
import { initCrossTabSession } from '../../../Libs/Auth/crossTabSession';
import { isGuestSurface } from '../../../Libs/Auth/guestSurface';
import CaptchaBox from "../../Captcha/CaptchaBox";

import NetworkInformation from "../../../Libs/Devices/NetworkInformation"

import { I18nProvider, I18nRemount } from '../../../Libs/i18n/I18nContext';
import EnvBanner from './EnvBanner';
import PrivateRoute from '../../../Libs/Security/PrivateRoutes';
import ShareOrPrivate from '../../../Libs/Security/ShareOrPrivate';
import Layouts from '../../Layouts/Component/Layouts';

import Logout from '../../LoginForm/Component/Logout';
import NotFound from '../../../Libs/Helper/NotFound'
import Errors from '../../../Libs/Helper/Errors'
import { Skeleton } from 'antd'
import { LoadScript } from '../../../Libs/Services/GoogleLoader'
import { isReservedSlug } from '../../Storefront/reserved';


const Login = React.lazy(() => import('../../../Pages/Login'));
const Experience = React.lazy(() => import('../../../Pages/Product/Experience'));
const ExperienceWizardContainer = React.lazy(() => import('../../Product/Experiences/Component/ExperienceWizardContainer'));
const ExperienceWizardPlaning = React.lazy(() => import('../../Product/Experiences/Component/ExperienceWizardPlaning'));

// Settings sayfaları (menü path'leri modules tablosundaki `value` ile eşleşir)
const SettingsCompany = React.lazy(() => import('../../../Pages/Settings/Company'));
const SettingsUsers = React.lazy(() => import('../../../Pages/Settings/Users'));
const SettingsTaxAndFee = React.lazy(() => import('../../../Pages/Settings/TaxAndFee'));
const SettingsCancelPolicy = React.lazy(() => import('../../../Pages/Settings/CancelPolicy'));
const SettingsBilling = React.lazy(() => import('../../../Pages/Settings/Billing'));
const SettingsPayment = React.lazy(() => import('../../../Pages/Settings/Payment'));
const SettingsPaymentGateway = React.lazy(() => import('../../../Pages/Settings/PaymentGateway'));
const SettingsDocuments = React.lazy(() => import('../../../Pages/Settings/Document'));
const SettingsInvitations = React.lazy(() => import('../../../Pages/Settings/Invitations'));
const SettingsSalesUsers = React.lazy(() => import('../../../Pages/Settings/SalesUsers'));
const SettingsPromoCode = React.lazy(() => import('../../../Pages/Settings/PromoCode'));
const SettingsWidgets = React.lazy(() => import('../../../Pages/Settings/Widgets'));
const SettingsStorefront = React.lazy(() => import('../../../Pages/Settings/Storefront'));
const SettingsSocialPost = React.lazy(() => import('../../../Pages/Settings/SocialPost'));
const SettingsPromoShare = React.lazy(() => import('../../../Pages/Settings/PromoShare'));
const SettingsApiKeys = React.lazy(() => import('../../../Pages/Settings/ApiKeys'));

// MakeBooking
const MakeBooking = React.lazy(() => import('../../../Pages/MakeBooking'));

// Wishlist paylaşım (public, guest)
const WishlistShare = React.lazy(() => import('../../MakeBooking/Components/WishlistShare'));
const WishlistAllShare = React.lazy(() => import('../../MakeBooking/Components/WishlistAllShare'));

// ProductView (detay) + guest paylaşımı
const ProductViewPage = React.lazy(() => import('../../../Pages/ProductView'));
// Hukuki metinler (public — terms/privacy/distance_sales)
const LegalDocPage = React.lazy(() => import('../../../Pages/LegalDoc'));
const ProductSharePage = React.lazy(() => import('../../../Pages/ProductShare'));
const PayLinkPage = React.lazy(() => import('../../../Pages/PayLink'));
const MemberInvitationPage = React.lazy(() => import('../../../Pages/MemberInvitation'));
const PayReturnPage = React.lazy(() => import('../../../Pages/PayReturn'));
const CheckoutPage = React.lazy(() => import('../../../Pages/Checkout'));
const CheckoutReservationPage = React.lazy(() => import('../../../Pages/Checkout').then(m => ({ default: m.CheckoutReservationPage })));
const UpdateBookingPage = React.lazy(() => import('../../../Pages/UpdateBooking'));
const ReservationPage = React.lazy(() => import('../../../Pages/Reservation'));
const ReservationDetailPage = React.lazy(() => import('../../../Pages/ReservationDetail'));
const ResourcesTownPage = React.lazy(() => import('../../../Pages/Resources/Town'));
const ResourcesVehiclePage = React.lazy(() => import('../../../Pages/Resources/Vehicle'));
const ResourcesGuidePage = React.lazy(() => import('../../../Pages/Resources/Guide'));
// Transfer (native gömülü admin ekranları — TransferScreen sarmalayıcısıyla)
const TransferScreen = React.lazy(() => import('../../Transfer/TransferScreen'));
const TransferVehicle = React.lazy(() => import('../../../Transfer/Components/Inventory/Vehicle/Vehicle'));
const TransferCategory = React.lazy(() => import('../../../Transfer/Components/Definitions/Category/Category'));
const TransferSegment = React.lazy(() => import('../../../Transfer/Components/Definitions/Segment/Segment'));
const TransferSupplier = React.lazy(() => import('../../../Transfer/Components/Definitions/Supplier/Supplier'));
const TransferAreaScreen = React.lazy(() => import('../../../Transfer/Components/Definitions/TransferArea/TransferArea'));
const TransferExtraService = React.lazy(() => import('../../../Transfer/Components/Definitions/ExtraService/ExtraService'));
const TransferFavoriteAddress = React.lazy(() => import('../../../Transfer/Components/Definitions/FavoriteAddress/FavoriteAddress'));
const TransferPrice = React.lazy(() => import('../../../Transfer/Components/Pricing/TransferPrice/TransferPrice'));
// Transfer rezervasyon motoru
const TransferBookingEngine = React.lazy(() => import('../../../Transfer/Components/Booking/TransferBooking'));
const TransferBookingDetails = React.lazy(() => import('../../../Transfer/Components/Booking/BookingDetails'));
const TransferBookingList = React.lazy(() => import('../../../Transfer/Components/Booking/BookingList'));
const TransferBookingView = React.lazy(() => import('../../../Transfer/Components/Booking/BookingView'));
const TransferBookingEdit = React.lazy(() => import('../../../Transfer/Components/Booking/BookingEdit'));
const OperationsManifestPage = React.lazy(() => import('../../../Pages/Operations/Manifest'));
const OperationsJobListPage = React.lazy(() => import('../../../Pages/Operations/JobList'));
const ReportMenuIncomePage = React.lazy(() => import('../../../Pages/ReportMenu/Income'));
const ReportMenuPayoutsPage = React.lazy(() => import('../../../Pages/ReportMenu/Payouts'));
const ReportMenuSalesPerfPage = React.lazy(() => import('../../../Pages/ReportMenu/SalesPerformance'));
const ReportMenuRefundsPage = React.lazy(() => import('../../../Pages/ReportMenu/Refunds'));
const ReportMenuCommissionPage = React.lazy(() => import('../../../Pages/ReportMenu/Commission'));
const DashboardPage = React.lazy(() => import('../../../Pages/Dashboard'));
const CommunicationPage = React.lazy(() => import('../../../Pages/Communication'));
const TicketsPage = React.lazy(() => import('../../../Pages/Tickets'));
const HelpPage = React.lazy(() => import('../../../Pages/Help'));

// Gömülebilir widget (public, partner key ile guest akışı)
const WidgetAppPage = React.lazy(() => import('../../../Pages/WidgetApp'));
// White-label hosted storefront (public, slug ile guest akışı)
const StorefrontAppPage = React.lazy(() => import('../../../Pages/StorefrontApp'));



// White-label website: {agency}.tourzone.com kökü → o acentenin sitesi (StorefrontApp).
// Rezerve subdomain'ler panel/api'dir; onlar normal uygulamayı açar.
//
// Liste PAYLAŞIMLI (Storefront/reserved.js → backend WidgetService ile aynı). Daha önce
// burada AYRI ve daha kısa bir liste vardı; iki liste birbirinden kaydığı için
// holideus* gibi panel host'ları storefront slug'ı sanılıp giriş ekranı yerine
// boş bir mağaza sayfası açılıyordu.
function storefrontHostSlug() {
    try {
        const parts = window.location.hostname.split('.');
        // IP ile erişimde (172.16.0.40) subdomain kavramı yok → panel aç.
        if (/^\d+\.\d+\.\d+\.\d+$/.test(window.location.hostname)) return null;
        if (parts.length >= 3 && !isReservedSlug(parts[0])) return parts[0];
    } catch (e) { /* ssr */ }
    return null;
}

export class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            recaptchaLoading: true
        }
        this.recaptchaRef = React.createRef();
        this.isComponentMounted = true;
    }
    componentDidMount() {
        this.init()
        // Çok-sekme oturum senkronu: başka sekmede logout → bu sekme de çıkış; farklı hesapla login → yenile.
        // Gömme yüzeyinde (widget iframe'i / storefront) KURULMAZ: orası panelin oturumuna ait değil.
        if (!isGuestSurface()) this.unsubscribeCrossTab = initCrossTabSession()
    }

    componentWillUnmount() {
        this.isComponentMounted = false;
        if (this.unsubscribeCrossTab) this.unsubscribeCrossTab()
    }

    init = async () => {
        try {
            // Yeni sekme / sayfa yenileme: token varsa oturumu geri yükle ki PrivateRoute
            // derin linki (ör. /ProductView/...) login'e atıp kaybetmesin.
            // Gömme yüzeyi guest'tir; paneldeki token'la oturum canlandırmaz (aynı localStorage'ı
            // paylaştıkları için ikinci bir oturum yaşam döngüsü paneli düşürebiliyordu).
            if (storageGet('token') && !isGuestSurface()) {
                this.props.bootAuth();
            }
            LoadScript();
            this.props.getApps();
        } catch (error) {

        }

    }


    asyncScriptOnLoad = () => {
        this.setState({
            recaptchaLoading: false
        })
    }

    render() {

        const { loading, error, errorData } = this.props.Apps;

        return (
            <>
                <EnvBanner />
                {(loading && this.state.recaptchaLoading) ?
                    <Loading />
                    :

                    <I18nProvider>
                        <BrowserRouter>
                          {/* Dil değişince routed içerik remount olur (getTranslate reaktif değil) — router DIŞTA korunur */}
                          <I18nRemount>
                            <Routes>
                                {/* {agency}.tourzone.com kökü → acentenin white-label sitesi; aksi halde panel/Login */}
                                <Route path='/' element={
                                    storefrontHostSlug()
                                        ? <Suspense fallback={<Loading />}><StorefrontAppPage /></Suspense>
                                        : <Suspense fallback={<Loading />}><Login recaptchaRef={this.recaptchaRef} /></Suspense>
                                } />



                                <Route path='/Logout' element={

                                    <Suspense fallback={<Loading />}>
                                        <Logout />
                                    </Suspense>
                                } />
                                <Route path='/Login' element={
                                    <Suspense fallback={<Loading />}>
                                        <Login recaptchaRef={this.recaptchaRef} />
                                    </Suspense>} />

                                {/* ---- Davet kabul / şifre belirleme (public, guest) ---- */}
                                <Route path='/Member-Invitation/:token' element={
                                    <Suspense fallback={<Loading />}><MemberInvitationPage /></Suspense>} />

                                {/* ---- Wishlist paylaşım (public, guest) ---- */}
                                <Route path='/share/wishlist/:code' element={
                                    <Suspense fallback={<Loading />}><WishlistShare /></Suspense>} />
                                <Route path='/share/wishlist-all/:token' element={
                                    <Suspense fallback={<Loading />}><WishlistAllShare /></Suspense>} />
                                <Route path='/Share/:slug/:ag/:code' element={
                                    <Suspense fallback={<Loading />}><ProductSharePage /></Suspense>} />
                                {/* Public ödeme linki (generatePaymentLink) — auth yok */}
                                <Route path='/pay/:code' element={
                                    <Suspense fallback={<Loading />}><PayLinkPage /></Suspense>} />
                                {/* Gateway dönüş sayfası (Yookassa redirect) — auth yok */}
                                <Route path='/Checkout/return/:rid' element={
                                    <Suspense fallback={<Loading />}><PayReturnPage /></Suspense>} />
                                {/* Hukuki metinler (public, guest — auth yok) */}
                                <Route path='/terms' element={
                                    <Suspense fallback={<Loading />}><LegalDocPage docType='terms' /></Suspense>} />
                                <Route path='/privacy' element={
                                    <Suspense fallback={<Loading />}><LegalDocPage docType='privacy' /></Suspense>} />
                                <Route path='/distance-sales' element={
                                    <Suspense fallback={<Loading />}><LegalDocPage docType='distance_sales' /></Suspense>} />
                                <Route path='/consumer-rights' element={
                                    <Suspense fallback={<Loading />}><LegalDocPage docType='consumer_rights' /></Suspense>} />
                                {/* Gömülebilir widget (public; iframe içinde dış sitede çalışır) */}
                                <Route path='/widget/search' element={
                                    <Suspense fallback={<Loading />}><WidgetAppPage /></Suspense>} />
                                {/* White-label hosted storefront (public; çok sayfalı, partner markalı) */}
                                <Route path='/store/:slug' element={
                                    <Suspense fallback={<Loading />}><StorefrontAppPage /></Suspense>} />
                                <Route path='/store/:slug/:page' element={
                                    <Suspense fallback={<Loading />}><StorefrontAppPage /></Suspense>} />
                                {/* Subdomain ({agency}.tourzone.com/about gibi) — yalnız storefront host'unda */}
                                {storefrontHostSlug() &&
                                    <Route path='/:page' element={
                                        <Suspense fallback={<Loading />}><StorefrontAppPage /></Suspense>} />}


                                <Route exact element={<PrivateRoute />}>
                                    <Route exact path="/Dashboard" element={
                                        <Layouts>
                                            <Suspense fallback={<Skeleton />}>
                                                <DashboardPage />
                                            </Suspense>
                                        </Layouts>
                                    } />

                                    <Route path="/Product/Experience" element={
                                        <Layouts>
                                            <Suspense fallback={<div>Loading...</div>}>
                                                <Experience />
                                            </Suspense>
                                        </Layouts>} />

                                    <Route path="/Product/Experience/ExperienceWizard/:id" element={
                                        <Layouts>
                                            <Suspense fallback={<div>Loading...</div>}>
                                                <ExperienceWizardContainer />
                                            </Suspense>
                                        </Layouts>} />

                                    <Route path="/Product/Experience/Planing/:id" element={
                                        <Layouts>
                                            <Suspense fallback={<div>Loading...</div>}>
                                                <ExperienceWizardPlaning />
                                            </Suspense>
                                        </Layouts>} />

                                    {/* ---- Settings ---- (path'ler modules.value ile birebir) */}
                                    <Route path="/Settings/Company" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsCompany /></Suspense></Layouts>} />
                                    <Route path="/Settings/Users" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsUsers /></Suspense></Layouts>} />
                                    <Route path="/Settings/TaxAndFee" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsTaxAndFee /></Suspense></Layouts>} />
                                    <Route path="/Settings/CancelPolicy" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsCancelPolicy /></Suspense></Layouts>} />
                                    <Route path="/Settings/Billing" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsBilling /></Suspense></Layouts>} />
                                    <Route path="/Settings/Payment" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsPayment /></Suspense></Layouts>} />
                                    <Route path="/Settings/PaymentGateway" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsPaymentGateway /></Suspense></Layouts>} />
                                    <Route path="/Settings/Documents" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsDocuments /></Suspense></Layouts>} />
                                    <Route path="/Settings/SalesRepresentative" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsSalesUsers /></Suspense></Layouts>} />
                                    <Route path="/Settings/PromoCode" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsPromoCode /></Suspense></Layouts>} />
                                    <Route path="/Settings/Widgets" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsWidgets /></Suspense></Layouts>} />
                                    <Route path="/Settings/Storefront" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsStorefront /></Suspense></Layouts>} />
                                    <Route path="/Settings/SocialPost" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsSocialPost /></Suspense></Layouts>} />
                                    <Route path="/Settings/PromoShare" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsPromoShare /></Suspense></Layouts>} />
                                    <Route path="/Settings/ApiKeys" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsApiKeys /></Suspense></Layouts>} />
                                    <Route path="/Invitations" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><SettingsInvitations /></Suspense></Layouts>} />

                                    {/* ---- Resources (Guide/Town/Vehicle) ---- */}
                                    <Route path="/Resources/Town" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ResourcesTownPage /></Suspense></Layouts>} />
                                    <Route path="/Resources/Vehicle" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ResourcesVehiclePage /></Suspense></Layouts>} />
                                    <Route path="/Resources/Guide" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ResourcesGuidePage /></Suspense></Layouts>} />

                                    {/* ---- Transfer (native gömülü — TourZone Layout içinde, transfer store/i18n) ---- */}
                                    <Route path="/Transfer/Vehicle" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferVehicle /></TransferScreen></Suspense></Layouts>} />
                                    <Route path="/Transfer/Categories" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferCategory /></TransferScreen></Suspense></Layouts>} />
                                    <Route path="/Transfer/Segments" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferSegment /></TransferScreen></Suspense></Layouts>} />
                                    <Route path="/Transfer/Suppliers" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferSupplier /></TransferScreen></Suspense></Layouts>} />
                                    <Route path="/Transfer/Areas" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferAreaScreen /></TransferScreen></Suspense></Layouts>} />
                                    <Route path="/Transfer/ExtraServices" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferExtraService /></TransferScreen></Suspense></Layouts>} />
                                    <Route path="/Transfer/FavoriteAddresses" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferFavoriteAddress /></TransferScreen></Suspense></Layouts>} />
                                    <Route path="/Transfer/Pricing" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferPrice /></TransferScreen></Suspense></Layouts>} />
                                    {/* Transfer rezervasyon motoru */}
                                    <Route path="/Transfer/Booking" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferBookingEngine /></TransferScreen></Suspense></Layouts>} />
                                    <Route path="/Transfer/BookingDetails" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferBookingDetails /></TransferScreen></Suspense></Layouts>} />
                                    <Route path="/Transfer/Bookings" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferBookingList /></TransferScreen></Suspense></Layouts>} />
                                    <Route path="/Transfer/BookingView/:id" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferBookingView /></TransferScreen></Suspense></Layouts>} />
                                    <Route path="/Transfer/BookingEdit/:id" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TransferScreen><TransferBookingEdit /></TransferScreen></Suspense></Layouts>} />

                                    {/* ---- Operations (Manifest / Job list) ---- */}
                                    <Route path="/Operations/Manifest" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><OperationsManifestPage /></Suspense></Layouts>} />
                                    <Route path="/Operations/JobList" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><OperationsJobListPage /></Suspense></Layouts>} />
                                    {/* Eski /Report/* yolları da aynı sayfalara bağlı (geri uyum) */}
                                    <Route path="/Report/Manifest" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><OperationsManifestPage /></Suspense></Layouts>} />
                                    <Route path="/Report/JobList" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><OperationsJobListPage /></Suspense></Layouts>} />

                                    {/* ---- ReportMenu (Income statement) ---- */}
                                    <Route path="/Report/Income-Statement" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReportMenuIncomePage /></Suspense></Layouts>} />
                                    <Route path="/ReportMenu/Income" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReportMenuIncomePage /></Suspense></Layouts>} />
                                    <Route path="/Report/Refunds" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReportMenuRefundsPage /></Suspense></Layouts>} />
                                    <Route path="/ReportMenu/Refunds" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReportMenuRefundsPage /></Suspense></Layouts>} />
                                    <Route path="/Report/Commission" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReportMenuCommissionPage /></Suspense></Layouts>} />
                                    <Route path="/Payouts" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReportMenuPayoutsPage /></Suspense></Layouts>} />
                                    <Route path="/ReportMenu/Payouts" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReportMenuPayoutsPage /></Suspense></Layouts>} />
                                    <Route path="/Report/Sales-Performance" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReportMenuSalesPerfPage /></Suspense></Layouts>} />
                                    <Route path="/Report/Performance" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReportMenuSalesPerfPage /></Suspense></Layouts>} />

                                    {/* ---- MakeBooking ---- */}
                                    <Route path="/MakeBooking" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><MakeBooking /></Suspense></Layouts>} />
                                    {/* Supplier offline booking (modules id53 /CreateBooking, supplier-only) — aynı booking akışı */}
                                    <Route path="/CreateBooking" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><MakeBooking /></Suspense></Layouts>} />
                                    <Route path="/Reservation" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReservationPage /></Suspense></Layouts>} />
                                    {/* Booking Messages (birleşik mesajlaşma) */}
                                    <Route path="/BookingMessages" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><CommunicationPage /></Suspense></Layouts>} />
                                    <Route path="/Communication" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><CommunicationPage /></Suspense></Layouts>} />
                                    {/* Support Tickets (partner destek — Help menüsü) */}
                                    <Route path="/Tickets" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><TicketsPage /></Suspense></Layouts>} />
                                    {/* FAQ / Yardım Merkezi (Help menüsü) */}
                                    <Route path="/Help" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><HelpPage /></Suspense></Layouts>} />
                                    {/* Mevcut menü öğesi "Bookings → See booking" (/SeeBooking) bu sayfaya bağlanır */}
                                    <Route path="/SeeBooking" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReservationPage /></Suspense></Layouts>} />
                                    {/* Rezervasyon detayı (liste göz butonu buraya gider) */}
                                    <Route path="/SeeBooking/BookingDetail/:id" element={
                                        <Layouts><Suspense fallback={<Skeleton />}><ReservationDetailPage /></Suspense></Layouts>} />
                                    <Route path="/ProductView/:slug/:ag" element={
                                        <Suspense fallback={<Skeleton />}><ProductViewPage /></Suspense>} />
                                    <Route path="/UpdateBooking/:reservationId" element={
                                        <Suspense fallback={<Skeleton />}><UpdateBookingPage /></Suspense>} />

                                    {/* TODO: child component'ler yapılınca route'ları aç:
                                        /Dashboard, /Members, /Definitions,
                                        /PointRules, /Tickets, /Reservations */}
                                </Route>

                                {/* ---- Checkout / ödeme: GİRİŞ YAPMIŞ veya SHARE oturumu (guest) erişebilir ---- */}
                                <Route exact element={<ShareOrPrivate />}>
                                    <Route path="/Checkout/reservation/:rid" element={
                                        <Suspense fallback={<Skeleton />}><CheckoutReservationPage /></Suspense>} />
                                    <Route path="/Checkout/:cartItemId" element={
                                        <Suspense fallback={<Skeleton />}><CheckoutPage /></Suspense>} />
                                </Route>

                                {/* TODO: AdminAuth modülü (AdminLogin / AdminLayouts /
                                    AdminPrivateRoute) yapılınca tüm /Admin/* route bloğunu aç. */}

                                <Route path="*" element={<NotFound />} />

                            </Routes>
                          </I18nRemount>
                        </BrowserRouter>
                        <NetworkInformation />

                        {/* Sağlayıcı (Google reCAPTCHA / Yandex SmartCaptcha) runtime-config'ten
                            seçilir; ref arayuzü aynı kaldığı için çağrı yerleri değişmedi.
                            onChange/onExpired KALDIRILDI: bu sınıfta tanımlı değillerdi
                            (undefined geçiliyordu), işlevsizdiler. */}
                        <CaptchaBox
                            ref={this.recaptchaRef}
                            badge={'bottomright'}
                            language={this.props.Apps && this.props.Apps.lang}
                            onLoaded={this.asyncScriptOnLoad}
                        />
                    </I18nProvider>
                }

                {error &&
                    <Errors errorData={errorData} />
                }

            </>
        )
    }
}

const mapStateToProps = (state) => ({
    Apps: state.Apps
})

const mapDispatchToProps = {
    getApps,
    setCaptcha,
    bootAuth: BootAuthReducer
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
